import { render, staticRenderFns } from "./PulseDiagnosis.vue?vue&type=template&id=27ee251e&scoped=true"
import script from "./PulseDiagnosis.vue?vue&type=script&lang=js"
export * from "./PulseDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./PulseDiagnosis.vue?vue&type=style&index=0&id=27ee251e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee251e",
  null
  
)

export default component.exports